import React, { useContext } from "react";
import { Stores, StoresContext } from "Globals/Stores";
import { PrivateRoute } from "Globals/Views/PrivateRoute";
import * as RouterUtil from "Utils/Routing";
import { StoresInstance } from "Globals/Stores";
import { AppUrls } from "../../AppUrls";
//import { ClientDetailView } from "./ClientDetailView";
import { ApprovalListView } from "./ApprovalListView";
import { InvoiceListView } from "./InvoiceListView";
import { LabourListView } from "./LabourListView";
import { ProjectListView } from "./ProjectListView";
import { PurchaseListView } from "./PurchaseListView";
import { StockListView } from "./StockListView";
import { SupplierListView } from "./SupplierListView";
import { VariationsListView } from "./VariationsListView";

import { DarwinLayout } from "Globals/Views/Layouts/DarwinLayout";

export const ApprovalRoutes: React.FC = () => {
    function getRootLayout() {
        return DarwinLayout;
    }

    const store = useContext<Stores>(StoresContext);
    return (
        <>
            <PrivateRoute
                exact
                path={AppUrls.Client.Approval.List}
                component={ApprovalListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireNotSiteManagerLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Approval.MyAmends}
                component={PurchaseListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireNotSiteManagerLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />
        </>
    );
};
